import type { ChronicleAmplitudeSource } from '../types';

export interface ChronicleBarsTuning {
  /** EMA smoothing for the noise-floor estimate (falls 5x faster than it rises). */
  floorAlpha: number;
  /** Gain mapping the above-floor delta onto 0..1 before the power curve. */
  deltaScale: number;
  /** Gamma < 1 expands small values so quiet speech stays visible. */
  power: number;
}

// streamRms is the 4.x fleet's curve — pinned by test, never retune it for
// 5.0. levelMeter fits FW 5.0 linear peaks: near-zero floor, deltas to ~0.5.
export const CHRONICLE_BARS_TUNING: Record<
  ChronicleAmplitudeSource,
  ChronicleBarsTuning
> = {
  streamRms: { floorAlpha: 0.01, deltaScale: 8, power: 0.55 },
  levelMeter: { floorAlpha: 0.01, deltaScale: 2, power: 0.55 },
};

export const advanceNoiseFloor = (
  floor: number | null,
  rms: number,
  tuning: ChronicleBarsTuning
): number => {
  if (floor === null) return rms;
  if (rms < floor) {
    const fallAlpha = tuning.floorAlpha * 5;
    return floor * (1 - fallAlpha) + rms * fallAlpha;
  }
  return floor * (1 - tuning.floorAlpha) + rms * tuning.floorAlpha;
};

export const driveFromRms = (
  rms: number,
  floor: number,
  tuning: ChronicleBarsTuning
): number => {
  const delta = Math.max(rms - floor, 0);
  const scaled = Math.min(delta * tuning.deltaScale, 1);
  return scaled > 0 ? Math.pow(scaled, tuning.power) : 0;
};
